/* ==========================================================================
   Wove — theme.js
   Core interactivity, no animation libraries. Runs on EVERY device.
   Handles: scroll-reveal (IntersectionObserver), header, mobile nav,
   accordions, cart drawer, add-to-cart (AJAX), add-to-cart upsell popup
   (Shopify product recommendations), sticky ATC, gallery, variants, email popup.
   ========================================================================== */
(function () {
  'use strict';
  var H = window.Wove || { routes: {}, strings: {} };
  var ROOT = (H.routes && H.routes.root) ? H.routes.root : '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/'; // '/en' -> '/en/'
  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  document.documentElement.classList.add('js');

  /* Scroll lock derived from ACTUAL open overlays (no fragile counter).
     Body scroll is frozen only while at least one overlay is open, and is
     always released once they're all closed — immune to open/close ordering. */
  function updateScrollLock() {
    var anyOpen = document.querySelector('.cart-drawer.is-open, .mobile-menu.is-open, .upsell-popup.is-open, .filter-drawer.is-open');
    document.body.style.overflow = anyOpen ? 'hidden' : '';
  }

  // Talformatet foelger butikkens sprog, ikke et fast dansk format.
  var numLocale = (H.locale || (window.Shopify && window.Shopify.locale) || 'da');
  var fmtCache = {};

  /* Prices are formatted with the STORE's own money format (window.Wove.moneyFormat,
     i.e. shop.money_format), not Intl.NumberFormat.

     Intl and Shopify genuinely disagree, and the mismatch is visible: a tier rendered
     by Liquid as "1 996 kr" was being rewritten by script into a different string the
     moment theme.js ran, so the three bundle tiers could not agree with each other.
     Reading the shop format keeps the currency symbol, its side, and the separators
     identical to every price Liquid renders.

     The house style of dropping ",00" on whole amounts is preserved — pair this with
     `money_without_trailing_zeros` in Liquid so first paint already matches. */
  var MONEY_FORMAT = (H.moneyFormat || '');
  var MONEY_PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  /* MONEY_FORMAT above is shop.money_format, which is the SHOP's format and does
     not follow the active market: on wove.fi and woves.co.uk it printed kroner
     separators and symbol over prices Liquid had already rendered correctly.
     H.moneyProbe is a known amount put through Liquid's own `money` filter,
     which IS market-aware, so its shape is the market's shape. Derived once. */
  var MONEY_SHAPE = (function (probe) {
    if (!probe) return null;
    var s = String(probe).replace(/<[^>]*>/g, "");
    var m = s.match(/\d[\d.,\s ']*\d|\d/);
    if (!m) return null;
    var num = m[0];
    var shape = { prefix: s.slice(0, m.index), suffix: s.slice(m.index + num.length), thousands: '', decimal: '.' };
    var dm = num.match(/([.,])(\d{2})$/);
    if (dm) { shape.decimal = dm[1]; num = num.slice(0, num.length - 3); }
    var tm = num.match(/[^\d]/);
    if (tm) shape.thousands = tm[0];
    return shape;
  })(H.moneyProbe);

  function groupNumber(cents, thousandsSep, decimalSep, decimals) {
    var n = Math.abs(cents / 100).toFixed(decimals);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    var out = parts.length > 1 ? parts[0] + decimalSep + parts[1] : parts[0];
    return (cents < 0 ? '-' : '') + out;
  }

  function money(cents) {
    // Oerer vises kun, naar beloebet faktisk har dem: 349 kr bliver ikke til 349,00 kr,
    // og 49,99 EUR bliver ikke rundet op til 50 EUR.
    var dec = Math.round(cents) % 100 === 0 ? 0 : 2;

    // The market's own shape wins over the shop-level format string.
    if (MONEY_SHAPE) {
      return MONEY_SHAPE.prefix +
        groupNumber(cents, MONEY_SHAPE.thousands, MONEY_SHAPE.decimal, dec) +
        MONEY_SHAPE.suffix;
    }

    var m = MONEY_FORMAT ? MONEY_FORMAT.match(MONEY_PLACEHOLDER) : null;
    if (m) {
      // The placeholder name is what declares the separator style, e.g.
      // {{amount_with_comma_separator}} => 1.234,56
      var name = m[1];
      var thousands = ',', decimal = '.';
      if (name.indexOf('comma_separator') > -1) { thousands = '.'; decimal = ','; }
      else if (name.indexOf('space_separator') > -1) { thousands = ' '; decimal = ','; }
      else if (name.indexOf('apostrophe_separator') > -1) { thousands = "'"; decimal = '.'; }
      return MONEY_FORMAT.replace(MONEY_PLACEHOLDER, groupNumber(cents, thousands, decimal, dec));
    }

    // No shop format available (e.g. the section rendered outside the layout) — fall
    // back to Intl rather than showing a raw number.
    var amount = cents / 100;
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
    var key = cur + ':' + dec;
    try {
      if (!fmtCache[key]) fmtCache[key] = new Intl.NumberFormat(numLocale, {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: dec,
        maximumFractionDigits: dec
      });
      return fmtCache[key].format(amount);
    } catch (e) { return amount.toFixed(dec) + ' ' + cur; }
  }
  // Sections with their own bundle engine format prices through the same function,
  // so every price on the page agrees no matter which script wrote it.
  window.WoveMoney = money;

  /* ============================================================
     SHARED: modern custom dropdown + colour swatches
     Used by the leggings bundle AND the standard product page.
     ============================================================ */
  // Danish colour names → cozy, muted home-textile swatch hexes. Longer/more specific
  // names are listed before generic ones so "støvet blå" wins over "blå".
  var WOVE_SW = [
    ['off-white','#EFE7DA'],['offwhite','#EFE7DA'],['natur','#EADFCD'],['ecru','#EADFCD'],['creme','#F1E9DA'],['cream','#F1E9DA'],
    ['hvid','#F1F1F1'],['white','#F1F1F1'],['vit','#F1F1F1'],
    ['lysegrå','#C7C4BD'],['lysegra','#C7C4BD'],['antracit','#3d3d3d'],['koksgrå','#3d3d3d'],['mørkegrå','#3d3d3d'],['morkegra','#3d3d3d'],['charcoal','#3d3d3d'],
    ['grå','#9a9a9a'],['graa','#9a9a9a'],['gra','#9a9a9a'],['grey','#9a9a9a'],['gray','#9a9a9a'],
    ['sort','#1b1b1b'],['black','#1b1b1b'],['svart','#1b1b1b'],
    ['salvie','#8C9A7B'],['sage','#8C9A7B'],['oliven','#6b6b3a'],['olive','#6b6b3a'],['oliv','#6b6b3a'],['khaki','#8f8b5a'],
    ['terracotta','#B5714F'],['terrakotta','#B5714F'],['rust','#A4553A'],['lerrød','#A4553A'],['lerrod','#A4553A'],
    ['karamel','#B98A5E'],['caramel','#B98A5E'],['kaffe','#6f4e37'],['coffee','#6f4e37'],['mocca','#6f4e37'],['brun','#6f4e37'],['brown','#6f4e37'],
    ['taupe','#B0A08E'],['muldvarp','#B0A08E'],['sand','#D9C2A6'],['beige','#D9C2A6'],['nude','#D9C2A6'],['champagne','#E6D5B8'],
    ['sennep','#C9A227'],['karry','#C9A227'],['mustard','#C9A227'],['gul','#E0C050'],['yellow','#E0C050'],
    ['støvet blå','#8EA6BD'],['stovet bla','#8EA6BD'],['dueblå','#8EA6BD'],['lyseblå','#A9C0D2'],['dusty blue','#8EA6BD'],
    ['marineblå','#1b2a4a'],['marine','#1b2a4a'],['navy','#1b2a4a'],['blå','#6D89A6'],['bla','#6D89A6'],['blue','#6D89A6'],
    ['gammelrosa','#D8B3AC'],['støvet rosa','#D8B3AC'],['stovet rosa','#D8B3AC'],['rosa','#D8B3AC'],['pink','#D8B3AC'],
    ['fersken','#E8C9A0'],['peach','#E8C9A0'],['aprikos','#E8C9A0'],['lavendel','#B9A6D4'],['lavender','#B9A6D4'],['lilla','#B9A0DC'],['purple','#7a3fa0'],
    ['grøn','#6F8F6A'],['gron','#6F8F6A'],['green','#6F8F6A'],['rød','#B4534A'],['rod','#B4534A'],['red','#B4534A'],

    /* Finnish, Dutch and the Swedish spellings that the Danish keys above do not
       cover. Without these, swatchFor fell through to its beige default: on
       wove.fi seven of the eight duvet colours rendered as the same beige dot,
       black included. Order does not matter here — the lookup below sorts by key
       length, so "mintgrön" wins over "grön" wherever it is written. */
    ['harmaa','#9a9a9a'],['grijs','#9a9a9a'],
    ['vaaleanharmaa','#C7C4BD'],['lichtgrijs','#C7C4BD'],
    ['tummanharmaa','#3d3d3d'],['donkergrijs','#3d3d3d'],
    ['musta','#1b1b1b'],['zwart','#1b1b1b'],
    ['valkoinen','#F1F1F1'],['wit','#F1F1F1'],
    ['mintgrøn','#9DBFAE'],['mintgrön','#9DBFAE'],['mintgrønn','#9DBFAE'],['mintgroen','#9DBFAE'],
    ['mintunvihreä','#9DBFAE'],['mint green','#9DBFAE'],['mint','#9DBFAE'],
    ['pebermynte','#9DBFAE'],['peppermint','#9DBFAE'],['pepermunt','#9DBFAE'],['piparminttu','#9DBFAE'],['pepparmynta','#9DBFAE'],
    ['tiffany','#9DBFAE'],
    ['grön','#6F8F6A'],['vihreä','#6F8F6A'],['groen','#6F8F6A'],
    ['orange','#D2732F'],['oransje','#D2732F'],['oranssi','#D2732F'],['oranje','#D2732F'],
    ['röd','#B4534A'],['punainen','#B4534A'],['rood','#B4534A'],
    ['vinrød','#8E2F3C'],['vinröd','#8E2F3C'],['wijnrood','#8E2F3C'],['viininpunainen','#8E2F3C'],['wine','#8E2F3C'],
    ['sininen','#6D89A6'],['blauw','#6D89A6'],
    ['himmelblå','#A9C0D2'],['hemelsblauw','#A9C0D2'],['sky blue','#A9C0D2'],['taivaansininen','#A9C0D2'],
    ['donkerblauw','#1b2a4a'],['tummansininen','#1b2a4a'],
    ['søblå','#4E7FA3'],['zeeblauw','#4E7FA3'],
    ['blåbær','#4A4E7C'],['bosbes','#4A4E7C'],['blueberry','#4A4E7C'],
    ['lila','#B9A0DC'],['liila','#B9A0DC'],['lilac','#B9A0DC'],['lyslilla','#B9A0DC'],
    ['paars','#7a3fa0'],['violetti','#7a3fa0'],
    ['laventeli','#B9A6D4'],
    ['roze','#D8B3AC'],['pinkki','#D8B3AC'],['vaaleanpunainen','#D8B3AC'],
    ['geel','#E0C050'],['keltainen','#E0C050'],
    ['bruin','#6f4e37'],['ruskea','#6f4e37'],
    ['hiekka','#D9C2A6'],['zand','#D9C2A6'],
    ['kerma','#F1E9DA'],['crème','#F1E9DA'],
    /* French and Italian, for the France and Italy markets. */
        /* French and Italian option values that exist on the store. */
    ['chêne foncé','#6B4A2F'],['rovere scuro','#6B4A2F'],['myrtille','#4A4E7C'],['mirtillo','#4A4E7C'],['menthe poivrée','#9DBFAE'],['menta piperita','#9DBFAE'],['pêche','#E8C9A0'],['pesca','#E8C9A0'],['vert tiffany','#9DBFAE'],['verde tiffany','#9DBFAE'],['cannelle','#B98A5E'],['cannella','#B98A5E'],['or rosé','#E8B4A0'],['oro rosa','#E8B4A0'],['noyer','#5A3A22'],['noce','#5A3A22'],['hêtre','#D8C09A'],['faggio','#D8C09A'],['café','#6f4e37'],['caffè','#6f4e37'],['chêne clair','#C8A97E'],['rovere chiaro','#C8A97E'],['gris pierre','#8E8E8B'],['grigio pietra','#8E8E8B'],['bleu layette','#A9C0D2'],['celeste','#A9C0D2'],['vert sauge','#8C9A7B'],['verde salvia','#8C9A7B'],['bleu mer','#4E7FA3'],['blu mare','#4E7FA3'],['vert citron','#8DBF4E'],['verde lime','#8DBF4E'],['violet royal','#7a3fa0'],['viola reale','#7a3fa0'],['viola','#B9A0DC'],['olive','#6B6B3A'],['oliva','#6B6B3A'],
    ['gris','#9a9a9a'],['grigio','#9a9a9a'],['gris clair','#C7C4BD'],['grigio chiaro','#C7C4BD'],['gris fonce','#3d3d3d'],['gris foncé','#3d3d3d'],['grigio scuro','#3d3d3d'],
    ['noir','#1b1b1b'],['nero','#1b1b1b'],['blanc','#F1F1F1'],['bianco','#F1F1F1'],
    ['vert menthe','#9DBFAE'],['verde menta','#9DBFAE'],['menthe','#9DBFAE'],['menta','#9DBFAE'],['vert','#6F8F6A'],['verde','#6F8F6A'],
    ['arancione','#D2732F'],['rouge','#B4534A'],['rosso','#B4534A'],['bordeaux','#8E2F3C'],
    ['bleu','#6D89A6'],['blu','#6D89A6'],['bleu ciel','#A9C0D2'],['azzurro','#A9C0D2'],['bleu marine','#1b2a4a'],['blu navy','#1b2a4a'],['blu scuro','#1b2a4a'],
    ['lilas','#B9A0DC'],['violet','#B9A0DC'],['viola','#7a3fa0'],['lavande','#B9A6D4'],['lavanda','#B9A6D4'],
    ['rose','#D8B3AC'],['jaune','#E0C050'],['giallo','#E0C050'],['marron','#6f4e37'],['marrone','#6f4e37'],['sable','#D9C2A6'],['sabbia','#D9C2A6'],['crema','#F1E9DA'],
    ['camel','#B98A5E'],['kanel','#B98A5E'],['cinnamon','#B98A5E'],['kaneel','#B98A5E'],['kaneli','#B98A5E'],
    ['stengrå','#8E8E8B'],['steengrijs','#8E8E8B'],['stone grey','#8E8E8B'],
    ['salviegrøn','#8C9A7B'],['saliegroen','#8C9A7B'],['salvia','#8C9A7B'],
    ['olijfgroen','#6b6b3a'],['oliivi','#6b6b3a'],['kaki','#8f8b5a'],
    ['limegrøn','#8DBF4E'],['limoengroen','#8DBF4E'],['lime','#8DBF4E'],

    /* Wood finishes — the shoehorn's only option. These missed in every market,
       so every finish showed the same beige dot. */
    ['ljus ek','#C8A97E'],['lys eg','#C8A97E'],['light oak','#C8A97E'],['licht eiken','#C8A97E'],['vaalea tammi','#C8A97E'],
    ['mörk ek','#6B4A2F'],['mørk eg','#6B4A2F'],['dark oak','#6B4A2F'],['donker eiken','#6B4A2F'],['tumma tammi','#6B4A2F'],
    ['valnöt','#5A3A22'],['valnød','#5A3A22'],['walnut','#5A3A22'],['notenhout','#5A3A22'],['pähkinä','#5A3A22'],
    ['beuken','#D8C09A'],['bøg','#D8C09A'],['beech','#D8C09A'],['bok','#D8C09A'],
    ['persika','#E8C9A0'],['persikka','#E8C9A0'],['perzik','#E8C9A0'],
    ['kahvi','#6f4e37'],['koffie','#6f4e37'],
    ['mustikka','#4A4E7C'],
    ['roosa','#D8B3AC'],['ruusukulta','#E8B4A0'],['rosaguld','#E8B4A0'],['rose gold','#E8B4A0'],['rosé goud','#E8B4A0'],
    ['kungslila','#7a3fa0'],['kongelilla','#7a3fa0'],['royal purple','#7a3fa0'],['koningspaars','#7a3fa0'],
    ['marinblå','#1b2a4a'],['laivastonsininen','#1b2a4a'],['marineblauw','#1b2a4a'],
    ['babyblå','#A9C0D2'],['babyblauw','#A9C0D2'],['vauvansininen','#A9C0D2']
  ];

  /* Patterns are not colours. They were falling through to the beige default and
     showing as a flat dot beside real colours, which reads as a broken swatch.
     Matched before the colour table so "Grön Äng" is a meadow, not plain green. */
  var WOVE_PATTERN = [
    [['horisont','horizon'],                                    'linear-gradient(#A9C0D2,#EFE7DA)'],
    [['ränder','rand','striber','stripe','raidat','streep'],     'repeating-linear-gradient(45deg,#E0C050 0 5px,#EFE7DA 5px 10px)'],
    [['blomm','blomst','kukka','kukat','bloem','flower','floral','äng','eng','meadow','niitty'], 'conic-gradient(#D8B3AC,#8C9A7B,#EFE7DA,#D8B3AC)'],
    [['prik','dot','pilkku','stip'],                             'radial-gradient(#E0C050 40%,#EFE7DA 42%)']
  ];
  /* Longest key first, so a compound like "mintgrön" is tested before "grön" and
     "marineblå" before "blå". Sorting here rather than relying on hand-ordering
     is what keeps the list safe to append to. */
  var WOVE_SW_ORDERED = WOVE_SW.slice().sort(function (a, b) { return b[0].length - a[0].length; });
  function swatchFor(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('batik') > -1 || n.indexOf('tie') > -1 || n.indexOf('dye') > -1) {
      if (n.indexOf('blå') > -1 || n.indexOf('bla') > -1 || n.indexOf('blue') > -1) return 'conic-gradient(#8EA6BD,#8C9A7B,#D9C2A6,#8EA6BD)';
      return 'conic-gradient(#B5714F,#D8B3AC,#8C9A7B,#B5714F)';
    }
    for (var p = 0; p < WOVE_PATTERN.length; p++) {
      for (var w = 0; w < WOVE_PATTERN[p][0].length; w++) {
        if (n.indexOf(WOVE_PATTERN[p][0][w]) > -1) return WOVE_PATTERN[p][1];
      }
    }
    for (var i = 0; i < WOVE_SW_ORDERED.length; i++) { if (n.indexOf(WOVE_SW_ORDERED[i][0]) > -1) return WOVE_SW_ORDERED[i][1]; }
    return '#D9C2A6';
  }
  // colorImg: { colourValue: imageUrl }. Builds the dropdown over a native <select>.
  function buildCustomSelect(sel, colorImg) {
    colorImg = colorImg || {};
    var isColor = sel.hasAttribute('data-color');
    var wrap = document.createElement('div');
    wrap.className = 'cselect' + (isColor ? ' cselect--color' : '') + (sel.classList.contains('bundle__select--size') ? ' cselect--size' : '');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'cselect__btn'; btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var menu = document.createElement('div'); menu.className = 'cselect__menu'; menu.setAttribute('role', 'listbox'); menu.hidden = true;
    function sw(name) {
      if (!isColor) return '';
      if (colorImg[name]) return '<i class="cselect__sw cselect__sw--img" style="background-image:url(' + colorImg[name] + ')"></i>';
      return '<i class="cselect__sw" style="background:' + swatchFor(name) + '"></i>';
    }
    function close() { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open'); }
    function setVal(val) {
      sel.value = val;
      btn.innerHTML = '<span class="cselect__cur">' + sw(val) + '<span>' + val + '</span></span><span class="cselect__caret"></span>';
      Array.prototype.forEach.call(menu.querySelectorAll('.cselect__opt'), function (o) { o.setAttribute('aria-selected', o.getAttribute('data-value') === val ? 'true' : 'false'); });
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    Array.prototype.forEach.call(sel.options, function (opt) {
      var o = document.createElement('div'); o.className = 'cselect__opt'; o.setAttribute('role', 'option'); o.setAttribute('data-value', opt.value);
      o.innerHTML = sw(opt.value) + '<span>' + opt.textContent + '</span>';
      o.addEventListener('click', function () { setVal(opt.value); close(); });
      menu.appendChild(o);
    });
    btn.addEventListener('click', function (e) { e.stopPropagation(); if (menu.hidden) { menu.hidden = false; btn.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open'); } else close(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    wrap.appendChild(btn); wrap.appendChild(menu);
    sel.style.display = 'none';
    sel.parentNode.insertBefore(wrap, sel.nextSibling);
    setVal(sel.value || (sel.options[0] && sel.options[0].value) || '');
  }
  // Build a { colourValue: thumbUrl } / { colourValue: imagePosition } map from a product's variants.
  function colourImageMaps(product, colorPos) {
    var img = {}, pos = {};
    if (colorPos) {
      product.variants.forEach(function (vr) {
        var cv = vr.options[colorPos - 1];
        if (cv && !img[cv] && vr.featured_image && vr.featured_image.src) {
          var s = vr.featured_image.src;
          img[cv] = s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=80&height=80&crop=center';
          pos[cv] = vr.featured_image.position;
        }
      });
    }
    return { img: img, pos: pos };
  }

  /* ============================================================
     1. SCROLL REVEAL — dependency-free, works on mobile + desktop
     ============================================================ */
  (function () {
    var items = document.querySelectorAll('.reveal-item');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          // gentle stagger based on position among siblings
          var siblings = el.parentElement ? el.parentElement.querySelectorAll('.reveal-item') : [el];
          var idx = Array.prototype.indexOf.call(siblings, el);
          el.style.transitionDelay = Math.min(idx, 6) * 70 + 'ms';
          el.classList.add('is-visible');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
    // Safety net: reveal anything still hidden after 2.5s (e.g. zero-height edge cases)
    setTimeout(function () {
      document.querySelectorAll('.reveal-item:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight + 200) el.classList.add('is-visible');
      });
    }, 2500);
  })();

  /* ============================================================
     2. HEADER + MOBILE NAV
     ============================================================ */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 60); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  var mobileMenu = document.querySelector('.mobile-menu');
  var menuOverlay = document.querySelector('.mobile-menu__overlay');
  var menuToggles = document.querySelectorAll('[data-menu-open]');
  function setToggleState(on) {
    menuToggles.forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    if (menuOverlay) menuOverlay.classList.add('is-active');
    mobileMenu.setAttribute('aria-hidden', 'false');
    setToggleState(true);
    updateScrollLock();
  }
  function closeNav() {
    if (!mobileMenu) return;
    if (!mobileMenu.classList.contains('is-open')) return;
    mobileMenu.classList.remove('is-open');
    if (menuOverlay) menuOverlay.classList.remove('is-active');
    mobileMenu.setAttribute('aria-hidden', 'true');
    setToggleState(false);
    updateScrollLock();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]')) { closeNav(); return; }
  });
  // Close the menu when a navigation link inside it is followed
  if (mobileMenu) {
    mobileMenu.querySelectorAll('.mobile-menu__nav a').forEach(function (a) {
      a.addEventListener('click', function () { closeNav(); });
    });
  }

  /* ============================================================
     3. ACCORDIONS
     ============================================================ */
  document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var body = btn.nextElementSibling;
      if (body) body.hidden = expanded;
    });
  });

  /* ============================================================
     4. CART DRAWER
     ============================================================ */
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-overlay');

  function openCart() {
    if (!drawer) return;
    closeNav();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');
    updateScrollLock();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    drawer.setAttribute('aria-hidden', 'true');
    updateScrollLock();
  }
  window.WoveOpenCart = openCart;
  window.WoveAddToCart = addToCart;

  // Event delegation so dynamically-added triggers work too
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); openCart(); fetchCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeUpsell(); closeNav(); }
  });

  // Seed compare-at prices from the product-page JSON so the cart can strike them
  (function () {
    window.Wove = window.Wove || {}; window.Wove.compareAt = window.Wove.compareAt || {};
    var pj = document.querySelector('[data-product-json]');
    if (!pj) return;
    try {
      var pd = JSON.parse(pj.textContent);
      (pd.variants || []).forEach(function (vr) {
        if (vr.compare_at_price && vr.compare_at_price > vr.price) window.Wove.compareAt[vr.id] = vr.compare_at_price;
      });
    } catch (e) {}
  })();

  /* ============================================================
     4b. FREE PILLOWCASES — derived, never accumulated
     ------------------------------------------------------------
     One 2-pack per duvet, always. The old behaviour added a gift line on every
     add-to-cart and merged it by variant, so the count could only grow, and
     removing a duvet left its gift behind: order #1328 shipped 16 two-packs
     against 2 duvets, in the wrong colour, because a gift line from an earlier
     attempt outlived the duvet that earned it.

     So the gift quantity is not something we add to. It is derived from the
     duvet count and rewritten on every read of the cart — which means add,
     quantity change and remove are all covered by one place, because they all
     end up here.
     ============================================================ */
  var GSYNC = H.giftSync || {};
  var DUVET_PID = parseInt(GSYNC.duvet, 10) || 0;
  var GIFT_PID = parseInt(GSYNC.gift, 10) || 0;
  var GIFT_VARIANT = parseInt(GSYNC.variant, 10) || 0;
  var reconciling = false;

  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function giftReconcile(cart) {
    // The pass itself mutates the cart, so it must never be able to trigger another.
    if (reconciling || !DUVET_PID || !GIFT_PID || !cart || !cart.items) return Promise.resolve(cart);

    var duvetQty = 0, giftQty = 0, gifts = [];
    cart.items.forEach(function (it, i) {
      if (it.product_id === DUVET_PID) duvetQty += it.quantity;
      else if (it.product_id === GIFT_PID) { giftQty += it.quantity; gifts.push({ i: i, qty: it.quantity }); }
    });
    if (giftQty === duvetQty) return Promise.resolve(cart);

    function settle(result) {
      reconciling = false;
      return (result && result.items) ? result : cart;
    }

    // Duvets with no gift line at all: there is nothing to grow, so add outright.
    if (giftQty < duvetQty && !gifts.length) {
      if (!GIFT_VARIANT) return Promise.resolve(cart);
      reconciling = true;
      return cartPost(H.routes.cart_add_url || ROOT + 'cart/add.js',
        { items: [{ id: GIFT_VARIANT, quantity: duvetQty - giftQty }] })
        .then(function () {
          return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); });
        })
        .then(settle, settle);
    }

    // Quantities for EVERY line, by position. Keying updates by variant id is
    // ambiguous the moment one variant sits on two lines, and a wrong key there
    // would reach past the gift and into somebody's shoehorn.
    var quantities = cart.items.map(function (it) { return it.quantity; });
    var delta = giftQty - duvetQty;

    if (delta > 0) {
      // Trim the colour with the most first, so the shade just chosen survives.
      while (delta > 0) {
        gifts.sort(function (a, b) { return b.qty - a.qty; });
        var top = gifts[0];
        if (!top || top.qty <= 0) break;
        var take = Math.min(delta, top.qty);
        top.qty -= take;
        delta -= take;
        quantities[top.i] = top.qty;
      }
    } else {
      gifts.sort(function (a, b) { return b.qty - a.qty; });
      gifts[0].qty += -delta;
      quantities[gifts[0].i] = gifts[0].qty;
    }

    reconciling = true;
    return cartPost(ROOT + 'cart/update.js', { updates: quantities }).then(settle, settle);
  }

  // Every path into the drawer goes through here, so the drawer always paints
  // the reconciled cart rather than the intermediate one.
  function renderCart(cart) {
    return giftReconcile(cart).then(paintCart);
  }

  function paintCart(cart) {
    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (!drawer) return;
    var itemsEl = drawer.querySelector('.cart-drawer__items');
    var footEl = drawer.querySelector('.cart-drawer__foot');
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-empty">' + (H.strings.cartEmpty || 'Din kurv er tom') + '</div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    if (footEl) footEl.style.display = '';

    var html = '';
    var CMP = (window.Wove && window.Wove.compareAt) || {};
    var DUVET_CMP = H.duvetCompare || {};
    var totalBaseline = 0;
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(_(\d+)x(\d+))?(\.[^.?]*)(\?.*)?$/, '_120x$4') : '';
      // Bundle / automatic discount tag(s) for this line
      var deal = '';
      var allocs = (item.line_level_discount_allocations && item.line_level_discount_allocations.length)
        ? item.line_level_discount_allocations : (item.discounts || []);
      allocs.forEach(function (a) {
        var title = a.title || (a.discount_application && a.discount_application.title) || 'Tilbud';
        deal += '<div class="cart-line__deal">🎁 ' + title + ' <b>−' + money(a.amount) + '</b></div>';
      });
      // Strike the higher of (pre-discount line price) or (compare-at × qty)
      var comparePer = item.compare_at_price || CMP[item.variant_id] || 0;
      // Sweden has no price list, so its contextual compare-at is null and both
      // sources above come back empty. Fall back to the locale figure, and only
      // when it is above what this line actually charges.
      if (!comparePer && DUVET_CMP.id && item.product_id === DUVET_CMP.id &&
          DUVET_CMP.cents > item.price) {
        comparePer = DUVET_CMP.cents;
      }
      var baseline = item.original_line_price;
      var compareLine = comparePer * item.quantity;
      if (compareLine > baseline) baseline = compareLine;
      totalBaseline += baseline;
      // A gift line is a real product at 0,00. "0,00 kr" reads as a pricing
      // bug, so free lines say so in words — from the locale, never hardcoded.
      var priceHtml;
      if (item.final_line_price === 0) {
        priceHtml = '<div class="cart-line__price cart-line__price--free">' +
          (H.strings.free || '') + '</div>';
      } else if (baseline > item.final_line_price) {
        priceHtml = '<s class="cart-line__was">' + money(baseline) + '</s>' +
          '<div class="cart-line__price cart-line__price--deal">' + money(item.final_line_price) + '</div>';
      } else {
        priceHtml = '<div class="cart-line__price">' + money(item.final_line_price) + '</div>';
      }
      // A gift line's quantity is derived from the duvet count, so it gets a
      // read-only figure instead of a stepper, and no remove link: removing one
      // on its own only puts the cart out of sync and reconciliation would put
      // it straight back, which reads as the page fighting the customer.
      var isGift = !!(GIFT_PID && item.product_id === GIFT_PID);
      var qtyHtml = isGift
        ? '<div class="cart-line__qty cart-line__qty--fixed"><span>' + item.quantity + '</span></div>' +
          (H.strings.giftNote ? '<div class="cart-line__gift">' + H.strings.giftNote + '</div>' : '')
        : '<div class="cart-line__qty"><button data-qty-down aria-label="' + (H.strings.qtyDown || 'Færre') + '">−</button>' +
          '<span>' + item.quantity + '</span><button data-qty-up aria-label="' + (H.strings.qtyUp || 'Flere') + '">+</button></div>';

      html += '<div class="cart-line" data-key="' + item.key + '">' +
        (img ? '<img src="' + img + '" alt="" width="64" height="80" loading="lazy">' : '<span></span>') +
        '<div><div class="cart-line__title">' + item.product_title + '</div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '') +
        deal + qtyHtml + '</div>' +
        '<div class="cart-line__pricing">' + priceHtml +
        (isGift ? '' : '<button class="cart-line__remove" data-remove>' + (H.strings.remove || 'Fjern') + '</button>') +
        '</div></div>';
    });
    itemsEl.innerHTML = html;

    var fs = H.freeShip || {};
    var threshold = fs.threshold || 34900; // per-market, in the market's own currency (minor units)
    var bar = drawer.querySelector('.cart-ship-bar i');
    var note = drawer.querySelector('.cart-ship-note');
    if (bar) {
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      bar.style.width = pct + '%';
      if (note) {
        var msg;
        if (cart.total_price >= threshold)  msg = fs.reached || '';
        else if (cart.total_price === 0)    msg = fs.empty || '';
        else {
          var left = money(threshold - cart.total_price);
          msg = (fs.progress || '[amount]').replace('[amount]', left);
        }
        note.innerHTML = msg;
      }
    }
    // Savings banner + struck original subtotal (compare-at and/or bundle discount)
    var savingsEl = drawer.querySelector('.cart-savings');
    var savingsAmt = drawer.querySelector('[data-cart-savings]');
    var wasEl = drawer.querySelector('[data-cart-was]');
    var woveSavings = totalBaseline - cart.total_price;
    if (woveSavings > 0) {
      if (savingsEl) savingsEl.hidden = false;
      if (savingsAmt) savingsAmt.textContent = '−' + money(woveSavings);
      if (wasEl) { wasEl.hidden = false; wasEl.textContent = money(totalBaseline); }
    } else {
      if (savingsEl) savingsEl.hidden = true;
      if (wasEl) wasEl.hidden = true;
    }
    var totalEl = drawer.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  // Delegated qty / remove inside drawer
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('.cart-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qty = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
      if (e.target.closest('[data-qty-up]')) changeQty(key, qty + 1);
      else if (e.target.closest('[data-qty-down]')) changeQty(key, qty - 1);
      else if (e.target.closest('[data-remove]')) changeQty(key, 0);
    });
  }

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  // Re-read and reconcile. Anything that changes the cart outside this file —
  // an app, a direct /cart/update.js call — can call this to pull the gift
  // count back in line instead of waiting for the next drawer interaction.
  window.WoveSyncCart = fetchCart;
  function changeQty(key, quantity) {
    fetch((H.routes.cart_change_url || ROOT + 'cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* ============================================================
     5. ADD TO CART (AJAX) — delegated, covers dynamic forms
     ============================================================ */
  function addToCart(items, btn, opts) {
    opts = opts || {};
    var original = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>…</span>'; }
    return fetch((H.routes.cart_add_url || ROOT + 'cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (btn) btn.innerHTML = '<span>' + (H.strings.addedToCart || 'Lagt i kurven') + '</span>';
        if (window.fbq) try { window.fbq('track', 'AddToCart'); } catch (e) {}
        return fetchCart().then(function () {
          var pid = null;
          if (data && data.items && data.items[0]) pid = data.items[0].product_id;
          else if (data && data.product_id) pid = data.product_id;
          if (opts.showUpsell !== false && pid) { showUpsell(pid); }
          else if (opts.openCartAfter !== false) { openCart(); }
          // adding from inside the upsell popup => openCartAfter:false => keep popup,
          // just refresh the count (avoids stacking the cart over the popup)
        });
      })
      .catch(function () {})
      .then(function () {
        setTimeout(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } }, 1400);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var upsellHost = form.closest('[data-upsell-popup]');
    // A static single-product popup has nothing left to offer once its one item
    // is added, so close it and show the cart instead of leaving the user stuck.
    var fromStatic = !!(upsellHost && upsellHost.hasAttribute('data-upsell-static'));
    var added = addToCart([{ id: parseInt(id.value, 10), quantity: qty }], form.querySelector('[type="submit"]'),
      { showUpsell: !upsellHost, openCartAfter: !upsellHost });
    if (fromStatic) added.then(function () { closeUpsell(); openCart(); });
  });

  // Frequently-bought-together button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fbt-add]');
    if (!btn) return;
    var form = btn.closest('[data-fbt-form]');
    if (!form) return;
    var items = [];
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      if (cb.value) items.push({ id: parseInt(cb.value, 10), quantity: 1 });
    });
    if (items.length) addToCart(items, btn, { showUpsell: true });
  });

  /* ============================================================
     6. ADD-TO-CART UPSELL POPUP — Shopify recommendations
     ============================================================ */
  // A template can supply its own static popup ([data-upsell-static], e.g. the
  // shoehorn PDP's "Har du børn?" cross-sell). It wins over the generic one.
  var upsell = document.querySelector('[data-upsell-static]') || document.querySelector('[data-upsell-popup]');
  function closeUpsell() {
    if (!upsell) return;
    upsell.classList.remove('is-open');
    updateScrollLock();
  }
  if (upsell) {
    upsell.addEventListener('click', function (e) {
      if (e.target.closest('[data-upsell-close]')) closeUpsell();
      if (e.target.closest('[data-upsell-cart]')) { closeUpsell(); openCart(); }
    });
  }
  function showUpsell(productId) {
    if (!upsell) { openCart(); return; }
    // Static popup: the product is already rendered in Liquid, nothing to fetch.
    if (upsell.hasAttribute('data-upsell-static')) {
      upsell.classList.add('is-open');
      updateScrollLock();
      return;
    }
    var listEl = upsell.querySelector('[data-upsell-items]');
    var url = ROOT + 'recommendations/products?section_id=product-recommendations&limit=4&intent=related&product_id=' + productId;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var tmp = document.createElement('div');
        tmp.innerHTML = txt;
        var found = tmp.querySelector('[data-rec-list]');
        if (found && found.children.length > 0) {
          listEl.innerHTML = found.innerHTML;
          upsell.classList.add('is-open');
          updateScrollLock();
        } else {
          openCart(); // no recommendations → just show the cart
        }
      })
      .catch(function () { openCart(); });
  }

  /* ============================================================
     7. STICKY MOBILE ATC
     ============================================================ */
  var mainAtc = document.querySelector('[data-product-form] [type="submit"]') || document.querySelector('[data-bundle-add]');
  var stickyAtc = document.querySelector('.sticky-atc');
  if (mainAtc && stickyAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(mainAtc);
  }

  /* ============================================================
     8. PDP GALLERY THUMBNAILS
     ============================================================ */
  (function () {
    var wrap = document.querySelector('.pdp__main-img');
    var slides = wrap ? wrap.querySelectorAll('.pdp__slide') : [];
    var thumbsWrap = document.querySelector('.pdp__thumbs');
    var thumbs = document.querySelectorAll('.pdp__thumbs button');
    if (!slides.length) return;
    var current = 0;

    function setSlide(i) {
      var n = slides.length;
      current = ((i % n) + n) % n; // wrap around
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', (parseInt(t.getAttribute('data-index'), 10) || 0) === current); });
    }
    window.WoveShowSlide = setSlide; // lets the colour picker drive the main image

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.hasAttribute('data-thumb-expand') && thumbsWrap) thumbsWrap.classList.remove('is-collapsed');
        setSlide(parseInt(thumb.getAttribute('data-index'), 10) || 0);
      });
    });

    // Prev / next arrow buttons
    var prev = wrap.querySelector('.pdp__nav--prev');
    var next = wrap.querySelector('.pdp__nav--next');
    if (prev) prev.addEventListener('click', function () { setSlide(current - 1); });
    if (next) next.addEventListener('click', function () { setSlide(current + 1); });

    // Touch swipe (mobile)
    var x0 = null, y0 = null;
    wrap.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      // horizontal swipe only (ignore vertical scroll)
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        setSlide(current + (dx < 0 ? 1 : -1));
      }
      x0 = null; y0 = null;
    }, { passive: true });
  })();

  /* ============================================================
     9. PDP VARIANT -> price / id / availability / sticky price
     ============================================================ */
  var pdpJson = document.querySelector('[data-product-json]');
  if (pdpJson) {
    var product = null;
    try { product = JSON.parse(pdpJson.textContent); } catch (e) {}
    var pform = document.querySelector('form[data-product-form]');
    if (product && pform) {
      var idField = pform.querySelector('[name="id"]');
      var priceEl = document.querySelector('.pdp__price [data-price]');
      var compareEl = document.querySelector('.pdp__price [data-compare-price]');
      var discountEl = document.querySelector('.pdp__price [data-discount]');
      var stickyPrice = document.querySelector('.sticky-atc__price');
      var submitSpan = pform.querySelector('[type="submit"] span');
      var submitBtn = pform.querySelector('[type="submit"]');
      var update = function () {
        var chosen = [];
        pform.querySelectorAll('.variant-group').forEach(function (g) {
          var sel = g.querySelector('input:checked');
          if (sel) chosen.push(sel.value);
        });
        var match = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        }) || product.variants[0];
        if (!match) return;
        if (idField) idField.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (stickyPrice) stickyPrice.textContent = money(match.price);
        // Compare-at price + discount badge per variant
        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        if (compareEl) {
          if (onSale) { compareEl.textContent = money(match.compare_at_price); compareEl.hidden = false; }
          else compareEl.hidden = true;
        }
        if (discountEl) {
          if (onSale) { discountEl.textContent = '−' + Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100) + '%'; discountEl.hidden = false; }
          else discountEl.hidden = true;
        }
        if (submitSpan) submitSpan.textContent = match.available ? (H.strings.addToCart || 'Læg i kurven') : (H.strings.soldOut || 'Udsolgt');
        if (submitBtn) submitBtn.disabled = !match.available;
      };
      pform.querySelectorAll('.variant-options input').forEach(function (i) {
        i.addEventListener('change', update);
      });
    }
  }

  /* ============================================================
     11. BEFORE / AFTER COMPARE SLIDER (drag: mouse + touch + keyboard)
     ============================================================ */
  document.querySelectorAll('[data-compare]').forEach(function (c) {
    var knob = c.querySelector('[data-compare-knob]');
    var dragging = false;
    function setPos(clientX) {
      var r = c.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      c.style.setProperty('--pos', pct + '%');
      if (knob) knob.setAttribute('aria-valuenow', Math.round(pct));
    }
    if (window.PointerEvent) {
      c.addEventListener('pointerdown', function (e) { dragging = true; setPos(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener('pointerup', function () { dragging = false; });
    } else {
      c.addEventListener('mousedown', function (e) { dragging = true; setPos(e.clientX); });
      window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener('mouseup', function () { dragging = false; });
      c.addEventListener('touchstart', function (e) { setPos(e.touches[0].clientX); }, { passive: true });
      c.addEventListener('touchmove', function (e) { setPos(e.touches[0].clientX); }, { passive: true });
    }
    if (knob) {
      knob.addEventListener('keydown', function (e) {
        var cur = parseFloat(getComputedStyle(c).getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft') { setVar(Math.max(0, cur - 4)); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setVar(Math.min(100, cur + 4)); e.preventDefault(); }
        function setVar(v) { c.style.setProperty('--pos', v + '%'); knob.setAttribute('aria-valuenow', Math.round(v)); }
      });
    }
  });

  /* ============================================================
     12. STATS COUNT-UP (animate on scroll into view)
     ============================================================ */
  (function () {
    var nums = document.querySelectorAll('[data-countup]');
    if (!nums.length) return;
    function fmt(v, decimals) {
      try { return new Intl.NumberFormat(numLocale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(v); }
      catch (e) { return v.toFixed(decimals); }
    }
    function run(el) {
      var raw = el.getAttribute('data-countup') || '';
      var pre = el.getAttribute('data-prefix') || '';
      var suf = el.getAttribute('data-suffix') || '';
      var target = parseFloat(String(raw).replace(',', '.'));
      if (isNaN(target)) { el.textContent = pre + raw + suf; return; }
      var decimals = (String(raw).split('.')[1] || '').length;
      if (reduced) { el.textContent = pre + fmt(target, decimals) + suf; return; }
      var dur = 1300, t0 = null;
      requestAnimationFrame(function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + fmt(target * eased, decimals) + suf;
        if (p < 1) requestAnimationFrame(step);
      });
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  })();

  /* ============================================================
     13. PRODUCT REVIEWS — pagination + photo lightbox
     ============================================================ */
  (function () {
    var list = document.querySelector('[data-reviews]');
    var pager = document.querySelector('[data-review-pager]');
    if (list && pager) {
      var cards = Array.prototype.slice.call(list.querySelectorAll('.rv'));
      var perPage = parseInt(list.getAttribute('data-per-page'), 10) || 6;
      var pageCount = Math.ceil(cards.length / perPage);
      var current = 1;
      function pageList(cur) {
        var keep = {}; [1, 2, pageCount - 1, pageCount, cur - 1, cur, cur + 1].forEach(function (n) { if (n >= 1 && n <= pageCount) keep[n] = 1; });
        var nums = Object.keys(keep).map(Number).sort(function (a, b) { return a - b; });
        var out = [], prev = 0;
        nums.forEach(function (n) { if (prev && n - prev > 1) out.push('…'); out.push(n); prev = n; });
        return out;
      }
      function renderPager() {
        var html = '<button type="button" data-nav="prev" aria-label="Föregående"' + (current === 1 ? ' disabled' : '') + '>‹</button>';
        pageList(current).forEach(function (n) {
          if (n === '…') html += '<span class="rvp-dots">…</span>';
          else html += '<button type="button" data-page="' + n + '"' + (n === current ? ' class="is-active"' : '') + '>' + n + '</button>';
        });
        html += '<button type="button" data-nav="next" aria-label="Nästa"' + (current === pageCount ? ' disabled' : '') + '>›</button>';
        pager.innerHTML = html;
      }
      function showPage(page) {
        current = Math.max(1, Math.min(pageCount, page));
        cards.forEach(function (c, i) {
          c.style.display = (i >= (current - 1) * perPage && i < current * perPage) ? '' : 'none';
        });
        renderPager();
      }
      pager.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || b.disabled) return;
        var nav = b.getAttribute('data-nav');
        if (nav === 'prev') showPage(current - 1);
        else if (nav === 'next') showPage(current + 1);
        else if (b.getAttribute('data-page')) showPage(parseInt(b.getAttribute('data-page'), 10));
        var anchor = document.getElementById('omdomen');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      showPage(1);
    }

    // Photo lightbox (delegated; works across pages)
    var lb = document.querySelector('[data-rv-lightbox]');
    if (lb) {
      var lbImg = lb.querySelector('[data-rv-img]');
      function closeLb() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); updateScrollLock(); }
      document.addEventListener('click', function (e) {
        var ph = e.target.closest('.rv__photo');
        if (ph) {
          var full = ph.getAttribute('data-full');
          if (full && lbImg) { lbImg.src = full; lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
          return;
        }
        if (e.target.closest('[data-rv-close]')) closeLb();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb(); });
    }
  })();

  /* ============================================================
     14. COLLECTION FILTER & SORT DRAWER
     ============================================================ */
  (function () {
    var drawer = document.querySelector('.filter-drawer');
    if (!drawer) return;
    function openD() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); updateScrollLock(); }
    function closeD() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); updateScrollLock(); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]')) { e.preventDefault(); openD(); return; }
      if (e.target.closest('[data-filter-close]')) { closeD(); return; }
      var head = e.target.closest('.filter-group__head');
      if (head) {
        var exp = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', String(!exp));
        var body = head.nextElementSibling;
        if (body) body.hidden = exp;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeD(); });

    var form = drawer.querySelector('[data-filter-form]');
    var instock = drawer.querySelector('[data-instock-toggle]');
    var applyCount = drawer.querySelector('[data-apply-count]');
    function updateApplyCount() {
      if (!applyCount) return;
      var n = form ? form.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked').length : 0;
      if (instock && instock.checked) n += 1;
      applyCount.textContent = n;
    }
    if (instock) {
      instock.addEventListener('change', function () {
        document.body.classList.toggle('hide-soldout', instock.checked);
        updateApplyCount();
      });
    }
    if (form) form.addEventListener('change', updateApplyCount);
    updateApplyCount();
  })();

  /* ============================================================
     15. BUNDLE — buy more, save more (per-pair colour + size)
     ============================================================ */
  (function () {
    var bundle = document.querySelector('[data-bundle]');
    if (!bundle) return;
    var product = null;
    var pj = document.querySelector('[data-product-json]');
    try { product = JSON.parse(pj.textContent); } catch (e) {}
    if (!product || !product.variants) return;
    var colorPos = parseInt(bundle.getAttribute('data-color-pos'), 10) || 0;
    var sizePos = parseInt(bundle.getAttribute('data-size-pos'), 10) || 0;
    // Slaas op paa ny hver gang: addToCart genskaber knappens indhold efter et
    // koeb, saa en cachet reference ville pege paa en loesrevet node.
    function totalNode() { return bundle.querySelector('[data-bundle-total]'); }
    var saveEl = bundle.querySelector('[data-bundle-save]');
    var addBtn = bundle.querySelector('[data-bundle-add]');

    // A position of 0 means the section could not match that option's name to
    // its alias list. Both guards in findVariant are then skipped, `ok` stays
    // true, and .find() hands back variants[0] — a variant differing in exactly
    // the dimension the customer chose. That is how a Dutch shopper picking one
    // colour received another. If any option is unaccounted for, resolve
    // nothing: every caller already treats a falsy variant as "cannot add".
    // Computed here rather than beside findVariant because refreshPrices() runs
    // on first paint, before that point in the file.
    var optNames = (product.options || []).map(function (o) {
      return String((o && o.name) || o || '').toLowerCase();
    });
    var identified = (colorPos ? 1 : 0) + (sizePos ? 1 : 0);
    var optsOk = identified === optNames.length ||
      (optNames.length === 1 && optNames[0] === 'title');
    if (!optsOk) {
      console.error(
        '[wove:bundle] Unidentified product option, so a selection cannot be resolved ' +
        'to a variant. Add the option name to the alias list in the product section. ' +
        'Options: ' + (optNames.join(', ') || '(none)') +
        ' — colour position ' + colorPos + ', size position ' + sizePos + '.'
      );
      if (addBtn) addBtn.disabled = true;
    }

    var qty = 1;

    /* ---- Colour -> image maps + build the dropdowns (shared helpers) ---- */
    var maps = colourImageMaps(product, colorPos);
    var colorImg = maps.img, colorImgPos = maps.pos;
    Array.prototype.forEach.call(bundle.querySelectorAll('.bundle__select'), function (sel) { buildCustomSelect(sel, colorImg); });

    /* ---- Tiers: reveal the chosen tier's pair pickers right below it ---- */
    // The variants chosen by a tier's pick rows (one per item in the pack)
    function selVariants(group) {
      var rows = group.querySelectorAll('.bundle__pick');
      if (!rows.length) return [product.variants[0]];
      return Array.prototype.map.call(rows, function (row) {
        var c = row.querySelector('[data-bundle-color]');
        var s = row.querySelector('[data-bundle-size]');
        return findVariant(c ? c.value : null, s ? s.value : null);
      });
    }
    function tierDiscount(group) {
      var input = group.querySelector('input[data-qty]');
      return input ? (parseInt(input.getAttribute('data-discount'), 10) || 0) : 0;
    }
    // now = sum of selected prices − fixed bundle discount (so every +100 size step adds +100)
    function tierNow(group) {
      var sum = 0;
      selVariants(group).forEach(function (v) { if (v) sum += v.price; });
      var now = sum - tierDiscount(group);
      return now < 0 ? 0 : now;
    }
    // was = struck compare-at (før) total for the deal look
    // Foer-prisen: variantens eget compare_at_price, ellers temaets faste
    // foer-pris pr. stk (data-unit-compare), ellers bare prisen selv.
    var unitCompare = parseInt(bundle.getAttribute('data-unit-compare'), 10) || 0;
    function tierWas(group) {
      var sum = 0;
      selVariants(group).forEach(function (v) {
        if (!v) return;
        var was = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0;
        if (!was && unitCompare > v.price) was = unitCompare;
        sum += was || v.price;
      });
      return sum;
    }
    function refreshPrices() {
      Array.prototype.forEach.call(bundle.querySelectorAll('.bundle__group'), function (g) {
        var now = tierNow(g), was = tierWas(g);
        var n = g.querySelector('.bundle__now'); if (n) n.textContent = money(now);
        var w = g.querySelector('.bundle__was');
        if (w) { if (was > now) { w.textContent = money(was); w.style.display = ''; } else { w.style.display = 'none'; } }
      });
      var ci = bundle.querySelector('input[data-qty]:checked');
      var grp = ci ? ci.closest('.bundle__group') : null;
      var totalEl = totalNode();
      if (grp && totalEl) totalEl.textContent = money(tierNow(grp));
      // Den klaebrige mobil-bjaelke viser samme total som knappen.
      var sticky = document.querySelector('.sticky-atc__price');
      if (grp && sticky) sticky.textContent = money(tierNow(grp));
      if (grp && saveEl) {
        var save = tierWas(grp) - tierNow(grp);
        // The whole sentence comes from the locale file. It used to be assembled as
        // 'Du sparer ' + amount, which forced every consumer to strip the Danish
        // label back off and re-wrap it — and any consumer that failed to strip it
        // rendered the label twice ("Du sparar Du sparer 499 kr").
        if (save > 0) {
          // If the key is somehow missing, fall back to the bare amount rather than
          // a hardcoded word — a wrong-language label is worse than no label.
          var tpl = (H.strings && H.strings.youSave) || '@@AMOUNT';
          saveEl.textContent = tpl.replace('@@AMOUNT', money(save));
          saveEl.hidden = false;
        } else saveEl.hidden = true;
      }
    }

    function selectTier(input) {
      qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
      Array.prototype.forEach.call(bundle.querySelectorAll('.bundle__group'), function (g) {
        var sel = g.contains(input);
        g.classList.toggle('is-selected', sel);
        var pk = g.querySelector('[data-picks]');
        if (pk) pk.hidden = !sel;
      });
      refreshPrices();
    }
    bundle.addEventListener('change', function (e) {
      if (!e.target.matches) return;
      if (e.target.matches('input[type=radio][data-qty]')) { selectTier(e.target); return; }
      if (e.target.matches('select[data-bundle-color], select[data-bundle-size]')) {
        refreshPrices();
        if (e.target.matches('select[data-bundle-color]')) {
          var pos = colorImgPos[e.target.value];
          if (pos && window.WoveShowSlide) {
            window.WoveShowSlide(pos - 1);
            var g = document.querySelector('.pdp__gallery') || document.querySelector('.pdp__main-img');
            if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    });
    var checked = bundle.querySelector('input[data-qty]:checked') || bundle.querySelector('input[data-qty]');
    if (checked) { checked.checked = true; selectTier(checked); }
    refreshPrices();

    function findVariant(color, size) {
      if (!optsOk) return undefined;
      return product.variants.find(function (vr) {
        var ok = true;
        if (colorPos) ok = ok && vr.options[colorPos - 1] === color;
        if (sizePos) ok = ok && vr.options[sizePos - 1] === size;
        return ok;
      });
    }
    if (addBtn) addBtn.addEventListener('click', function () {
      var ci = bundle.querySelector('input[data-qty]:checked');
      var group = ci ? ci.closest('.bundle__group') : null;
      var items = [], missing = false;
      var rows = group ? Array.prototype.slice.call(group.querySelectorAll('.bundle__pick')) : [];
      if (!rows.length) {
        items.push({ id: product.variants[0].id, quantity: qty });
      } else {
        rows.forEach(function (row) {
          var c = row.querySelector('[data-bundle-color]');
          var s = row.querySelector('[data-bundle-size]');
          var variant = findVariant(c ? c.value : null, s ? s.value : null);
          if (variant && variant.available !== false) items.push({ id: variant.id, quantity: 1 });
          else missing = true;
        });
      }
      if (missing || !items.length) { alert(H.strings.comboUnavailable || 'Den kombination er desværre udsolgt lige nu — vælg en anden farve eller størrelse.'); return; }
      var merged = {};
      items.forEach(function (it) { merged[it.id] = (merged[it.id] || 0) + it.quantity; });
      var finalItems = Object.keys(merged).map(function (id) { return { id: parseInt(id, 10), quantity: merged[id] }; });
      addToCart(finalItems, addBtn, { showUpsell: true });
    });
  })();

  /* ============================================================
     16. STANDARD PRODUCT PAGE — colour/size dropdowns + image swap
         (same custom selects as the leggings bundle, single ATC)
     ============================================================ */
  (function () {
    var form = document.querySelector('[data-variant-form]');
    if (!form) return;
    var product = null;
    var pj = document.querySelector('[data-product-json]');
    try { product = JSON.parse(pj.textContent); } catch (e) {}
    if (!product || !product.variants) return;

    var selects = form.querySelectorAll('select[data-variant-option]');
    if (!selects.length) return;
    var colorSel = form.querySelector('select[data-variant-color]');
    var colorPos = colorSel ? (parseInt(colorSel.getAttribute('data-position'), 10) || 0) : 0;
    var maps = colourImageMaps(product, colorPos);
    Array.prototype.forEach.call(selects, function (sel) { buildCustomSelect(sel, maps.img); });

    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('.pdp__price [data-price]');
    var compareEl = document.querySelector('.pdp__price [data-compare-price]');
    var discountEl = document.querySelector('.pdp__price [data-discount]');
    var submitBtn = form.querySelector('[type="submit"]');
    var submitSpan = submitBtn ? submitBtn.querySelector('span') : null;
    var stickyPrice = document.querySelector('.sticky-atc__price');

    function chosen() {
      var arr = [];
      Array.prototype.forEach.call(selects, function (s) {
        arr[(parseInt(s.getAttribute('data-position'), 10) || 1) - 1] = s.value;
      });
      return arr;
    }
    function update() {
      var ch = chosen();
      var match = product.variants.find(function (vr) {
        return vr.options.every(function (o, i) { return ch[i] == null || o === ch[i]; });
      }) || product.variants[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      if (compareEl) {
        if (onSale) { compareEl.textContent = money(match.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (discountEl) {
        if (onSale) { discountEl.textContent = '−' + Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100) + '%'; discountEl.hidden = false; }
        else discountEl.hidden = true;
      }
      if (submitSpan) submitSpan.textContent = match.available ? (H.strings.addToCart || 'Læg i kurven') : (H.strings.soldOut || 'Udsolgt');
      if (submitBtn) submitBtn.disabled = !match.available;
    }
    form.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('select[data-variant-option]')) return;
      update();
      if (e.target.matches('[data-variant-color]')) {
        var pos = maps.pos[e.target.value];
        if (pos && window.WoveShowSlide) window.WoveShowSlide(pos - 1);
      }
    });
    update();
  })();

  /* ---- Initial cart bubble sync ---- */
  fetchCart();
})();
